import React from 'react'

export default function ImageSlider({ duonutthumbnail_set, currentIndex, previousIndex }) {

    return (
        <>
            {duonutthumbnail_set.map((set, idx) => {
                return <img src={set.thumbnail} key={set.id}
                    alt=""
                    className={currentIndex === idx ? 'active' : 
                    idx === previousIndex ? 'previous' : 'in-active'}
                />
            })}
        </>
    )
}
